// Aug-2026 (User-Wunsch) — Einstellungs-Zahnräder app-weit NUR für Admin +
// freigegebene Accounts sichtbar; Liste ist im Admin-Bereich pflegbar
// (GET /api/me/gear-access, Verwaltung unter /admin/konten).
// (Cookie-Einstellungen bleiben aus rechtlichen Gründen für alle sichtbar.)
import { useEffect, useState } from "react";
import { useAuth } from "./auth";
import api from "./api";

// Fallback, solange der Server nicht geantwortet hat (identisch zum Backend-Default).
export const GEAR_ALLOWED_EMAILS = [
    "joerg.scholz@autohaus-koenig.de",
    "scholz.home@icloud.com",
    "scholz.home1@gmail.com",
    "martin.schroeder@autohaus-koenig.de",
];

const _mail = (v) => String(v || "").toLowerCase();

export const canSeeGears = (user) =>
    !!user && user !== false &&
    (user.role === "admin" ||
        GEAR_ALLOWED_EMAILS.includes(_mail(user.email)) ||
        GEAR_ALLOWED_EMAILS.includes(_mail(user.email_dedupe_original)) ||
        GEAR_ALLOWED_EMAILS.includes(_mail(user.login_email)));

// Modul-Cache: 1 Request pro Seiten-Session, alle Hook-Instanzen teilen ihn.
let _cached = null;
let _promise = null;

export const useGearsVisible = () => {
    const { user } = useAuth();
    const [ok, setOk] = useState(_cached !== null ? _cached : canSeeGears(user));
    useEffect(() => {
        if (!user || user === false) { setOk(false); return; }
        if (_cached !== null) { setOk(_cached); return; }
        if (!_promise) {
            _promise = api.get("/me/gear-access")
                .then((r) => { _cached = !!r.data?.allowed; return _cached; })
                .catch(() => canSeeGears(user));
        }
        let alive = true;
        _promise.then((v) => { if (alive) setOk(v); });
        return () => { alive = false; };
    }, [user]);
    return ok;
};
